<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space clickable" @click="msgAlerta=null"><span class="text">{{ msgAlerta }}</span></div>


    <div v-show="!modoEdicao">
        <div class="form-edit-page row-space">
            <div class="row row-space">
                <div class="form-item-char10">
                    <label class="label-caption">Pasta</label>
                    <div class="field-label field-label-end">{{ Funcoes.formatInteger(objView.id) }}</div>
                </div>

                <div class="form-item">
                    <label class="label-caption">Nome/Identificação</label>
                    <div class="field-label field-label--destaque">{{ objView.nmpasta }}</div>
                </div>
                <div v-if="!showForm" class="row-end">
                    <button class="btn-small" @click="novoArquivo">Novo Arquivo</button>
                    <button class="btn-small" @click="closeForm">Retornar</button>
                </div>
            </div>
        </div>


        
        <div v-if="lsDados.length>0 && !showForm" class="table-wrapper"><table>
            <thead><tr>
                <th>Data</th>
                <th>Nome/Dscrição</th>
                <th>Tipo</th>
                <th>Situação</th>
            </tr></thead>
            
            <tbody><tr v-for="(obj, index) in lsDados" :key="obj.id" @click="editarCadastro(obj)" 
                :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}">
                    <td class="col-width-char10 center">{{ Funcoes.formatDateFromJson(obj.dtanexo) }}</td>
                    <td>{{ obj.nmdoc }}</td>
                    <td  class="col-width-char20">{{ obj.tiponm }}</td>
                    <td  class="col-width-char10 center">{{ obj.nmativo }}</td>
            </tr></tbody>
        </table></div>


        <div v-if="showPagination" class="pagination">
            <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
            <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
            <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
        </div>
    </div>


    <div v-if="modoEdicao">
        <AnexoUploadPage :idAnexoGrupo="7" :idDrivePasta="objView.id" @close="modoEdicao = false" @save="listarArquivos" />
    </div>

    <div v-if="showForm" class="form-edit-page">
        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption">Nome/Identificação</label>
                <input type="text" v-model="docAnexo.nmdoc" maxlength="100" v-uppercase />
            </div>
            
            <div class="form-item-char15">
                <label class="label-caption" >Valido Até</label>
                <input type="date" v-model="docAnexo.dtvalidade" />
            </div>
        </div>


        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption">Observações</label>
                <textarea v-model="docAnexo.obspostagem" maxlength="2000" rows="5" style="resize: none;"/>
            </div>
        </div>
        

        <div class="row-end">
            <button v-if="docAnexo.id" @click="lerAnexo">Visualizar</button>
            <button type="button" @click="showForm=false">Cancelar</button>
            <button type="button" class="btn-cancel" @click="excluirRegistro">Excluir</button>
            <button type="button" class="btn-confirm" @click="salvarDados">Salvar</button>
        </div>
    </div>

    <ConfirmModal ref="confirmModal" />
</template>


<script setup>
import { onMounted, ref, reactive } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/funcoes';
import { globalStore } from '@/globals';
import AnexoUploadPage from '@/components/operacoes/AnexoUploadPage.vue';
import ConfirmModal from '@/components/modals/ConfirmModal.vue';

const emit = defineEmits(['close']);
const props = defineProps({idPasta: {type: Number, default: 0}});

const confirmModal = ref(null);
const idEdicao = ref(0);
const isLoading = ref(false);
const isLoadingAnexo = ref(false);
const lsDados = ref([]);
const modoEdicao = ref(false);
const msgAlerta = ref(null);
const showForm = ref(false);

const objView = ref({});
const docAnexo = reactive({id: 0, nmdoc: '', dtvalidade: '', obspostagem: '', idlogin: 0});

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);
const lsDadosMain = ref([]);
const showPagination = ref(false);

const closeForm = () => {emit('close');}

const editarCadastro = (obj) => {
    idEdicao.value = obj.id;
    docAnexo.id = obj.idanexo;
    docAnexo.nmdoc = obj.nmdoc;
    docAnexo.dtvalidade = obj.dtvalidade;
    docAnexo.obspostagem = obj.obspostagem;
    docAnexo.idlogin = globalStore.idlogin;
    showForm.value = true;
}


async function excluirRegistro(){
    const confirmado = await confirmModal.value.show({
        message: 'Confirma exclusão deste arquivo do Drive?',
        confirmText: 'SIM',
        cancelText: 'NÃO',
    });
    if (!confirmado) return;

    try {
        isLoading.value=true;
        const response = await Api.genericPut('/cad/drive/arquivo', {id: idEdicao.value, ativo: 'N', idlogin: globalStore.idlogin});
        if (response.bolok === 1){
            await listarArquivos();
            showForm.value=false;
        }else{
            msgAlerta.value = response.erro;
        }
    } catch (error) {msgAlerta.value = error;
    } finally{isLoading.value=false;}
}


async function lerAnexo() {
    try{
        msgAlerta.value=null;
        isLoadingAnexo.value = true;
        const r = await Api.genericPost('/operacoes/solicitar/download', {id: docAnexo.id});
        if (r.bolok === 1){
            const url = r.download_url;
            window.open(url, '_blank');
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoadingAnexo.value = false;}

    console.log("Ler anexo...", docAnexo.id);
}


const lerDados = async() => {
    try{
        msgAlerta.value = null;
        isLoading.value = true;
        const req = await Api.genericPost('/listas/drive/pastas', {
            idep: globalStore.idep,
            id: props.idPasta});
        Object.assign(objView.value, req[0]);
        listarArquivos();
    } catch (error){msgAlerta.value= error;
    } finally {isLoading.value = false;}
}


async function listarArquivos(){
    try{
        msgAlerta.value = null;
        isLoading.value = true;
        const req = await Api.genericPost('/listas/drive/arquivos', {
            idep: globalStore.idep,
            ativo: 'S',
            intparam1: objView.value.id});
        lsDadosMain.value = req;
        currentPage.value=1;
        showPagination.value = (lsDadosMain.value.length > itemsPerPage.value);
        updatePaginatedData();
    } catch (error){msgAlerta.value= error;
    } finally {isLoading.value = false;}
}


function novoArquivo() {
    modoEdicao.value = true;
}


async function salvarDados(){
    let x = "";
    msgAlerta.value=null;
    if (!docAnexo.nmdoc) x += '\n-Informe nome/identificação';
    if (!docAnexo.obspostagem) x += '\n-Informe observações do arquivo';
    if (x){
        msgAlerta.value=`ATENÇÃO:${x}`;
        return;
    }

    try {
        isLoading.value=true;
        const response = await Api.genericPut('/cad/anexo', docAnexo);
        if (response.bolok === 1){
            await listarArquivos();
            showForm.value=false;
        }else{
            msgAlerta.value = response.erro;
        }
    } catch (error) {msgAlerta.value = error;
    } finally{isLoading.value=false;}
}


const updatePaginatedData = () => {
    const startIndex = (currentPage.value - 1) * itemsPerPage.value;
    const endIndex = (startIndex + itemsPerPage.value);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}


onMounted(lerDados);
</script>